const _classes = {
  "list-item": "cui-list-item-znju",
  "list-item-destructive": "cui-list-item-destructive-rt4k",
  "navigation-item": "cui-navigation-item-bhz8",
  "animation-fade-in": "cui-animation-fade-in-tkyx",
  "animation-fade-out": "cui-animation-fade-out-ybhy",
  "animation-slide-up-in": "cui-animation-slide-up-in-bnhp",
  "animation-slide-up-out": "cui-animation-slide-up-out-drpb",
  "animation-slide-down-in": "cui-animation-slide-down-in-l4vp",
  "animation-slide-down-out": "cui-animation-slide-down-out-covh"
};
export {
  _classes as default
};
